module.exports = __webpack_public_path__ + "img/lrb_logo.945d0f66.png";